import React from "react";
import { ShieldCheck, BadgeCheck, IdCard, Users, Clock, Heart, Sparkles } from "lucide-react";

const TIMELINE_LABEL = {
  ready: "Klar til ægteskab",
  "6m": "Inden 6 mdr.",
  "1y": "Inden 1 år",
  "1_2y": "1-2 år",
  exploring: "Udforsker seriøst",
};

/**
 * Compact horizontal row of trust signals shown at the top of a profile.
 * Falls back gracefully when fields are missing.
 */
export default function TrustBadges({ profile, className = "" }) {
  if (!profile) return null;
  const vs = profile.verification_status || {};
  const badges = [];

  if (vs.selfie) badges.push({ icon: <ShieldCheck className="h-3.5 w-3.5" />, label: "Verificeret ansigt", tone: "olive", testid: "tb-verified-face" });
  if (vs.identity) badges.push({ icon: <IdCard className="h-3.5 w-3.5" />, label: "Verificeret ID", tone: "olive", testid: "tb-verified-id" });
  else if (profile.verified) badges.push({ icon: <BadgeCheck className="h-3.5 w-3.5" />, label: "Verificeret", tone: "sky", testid: "tb-verified" });

  if (profile.has_wali || (profile.wali_email || "").length) {
    badges.push({ icon: <Users className="h-3.5 w-3.5" />, label: "Wali involveret", tone: "olive", testid: "tb-wali" });
  }
  if (profile.boosted) {
    badges.push({ icon: <Sparkles className="h-3.5 w-3.5" />, label: "Boosted", tone: "gold", testid: "tb-boosted" });
  }
  const timeline = profile.marriage_timeline || profile.pref_marriage_timeline;
  if (timeline && TIMELINE_LABEL[timeline]) {
    badges.push({ icon: <Heart className="h-3.5 w-3.5" />, label: TIMELINE_LABEL[timeline], tone: "rose", testid: "tb-timeline" });
  }
  if (profile.updated_at) {
    const days = Math.floor((Date.now() - new Date(profile.updated_at).getTime()) / 86400000);
    if (days <= 7) badges.push({ icon: <Clock className="h-3.5 w-3.5" />, label: days === 0 ? "Aktiv i dag" : `Aktiv for ${days} dg. siden`, tone: "green", testid: "tb-active" });
  }

  if (!badges.length) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="trust-badges">
      {badges.map((b, i) => (
        <span
          key={i}
          className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium backdrop-blur bg-white/85 border ${TONE[b.tone]}`}
          data-testid={b.testid}
          title={b.label}
        >
          {b.icon} {b.label}
        </span>
      ))}
    </div>
  );
}

const TONE = {
  olive: "text-olive-700 border-olive-500/40",
  sky:   "text-sky-700 border-sky-500/40",
  gold:  "text-gold-700 border-gold-500/50 bg-gold-100/70",
  rose:  "text-rose-700 border-rose-500/40",
  green: "text-emerald-700 border-emerald-500/40",
};
